var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

const SvgIconHamburgerMenuSmall = (_ref) => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3 6.071C3 5.478 3.478 5 4.071 5H21.93C22.522 5 23 5.478 23 6.071c0 .594-.478 1.072-1.071 1.072H4.07A1.069 1.069 0 0 1 3 6.07zm0 7.143c0-.594.478-1.071 1.071-1.071H21.93c.593 0 1.071.477 1.071 1.071s-.478 1.072-1.071 1.072H4.07A1.069 1.069 0 0 1 3 13.214zm20 7.143c0 .594-.478 1.071-1.071 1.071H4.07A1.069 1.069 0 0 1 3 20.357c0-.594.478-1.071 1.071-1.071H21.93c.593 0 1.071.477 1.071 1.071z",
    fill: "#1A202C",
    fillRule: "nonzero"
  })));
};

const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgIconHamburgerMenuSmall, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/icon-hamburger-menu-small.1cdeb2d3.svg";
export { ForwardRef as ReactComponent };